import { motion } from 'framer-motion';
import { Target, ShieldCheck, Rocket, GitMerge, Scale } from 'lucide-react';

const differentiators = [
  { icon: Target, text: 'Multi-domain execution — one partner' },
  { icon: ShieldCheck, text: 'Agile + Government Compliance expertise' },
  { icon: Rocket, text: 'Rapid deployment, minimal onboarding friction' },
  { icon: GitMerge, text: 'Bridges technical, operational, and strategic gaps' },
  { icon: Scale, text: 'Built for scalability across contracts and agencies' },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-24 lg:py-32 bg-[#141414]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
              The Advantage
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
              Why Cole Utilities
            </h2>
            <p className="font-body text-[#A3A3A3] max-w-lg">
              A single execution partner that operates across domains — delivering
              speed, compliance, and results without compromise.
            </p>
          </motion.div>

          <div className="space-y-4">
            {differentiators.map((item, i) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  data-testid={`differentiator-${i}`}
                  className="flex items-center gap-4 p-4 border border-[#2A2A2A] rounded-lg hover:border-[#B8102E]/40 transition-all duration-300 group bg-[#0A0A0A]"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#B8102E]/10 flex items-center justify-center group-hover:bg-[#B8102E]/20 transition-colors">
                    <Icon className="h-5 w-5 text-[#B8102E]" />
                  </div>
                  <p className="font-body text-sm text-white font-medium">
                    {item.text}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
